<template>
  <WorkTableDialog
    ref="deputyDialog"
    :headers="headers"
    path="users/deputies"
    :mandatory-filters="{ isActive: true }"
    :title="$t('DeputyPopup.title')"
  />
</template>

<script>
import WorkTableDialog from "@/components/base_components/dialog/table_dialogs/WorkTableDialog";

export default {
  name: "DeputyDialog",
  components: { WorkTableDialog },
  data() {
    return {
      headers: [
        { text: this.$t('DeputyPopup.columnHeaders.firstName'), value: "firstName" },
        { text: this.$t('DeputyPopup.columnHeaders.lastName'), value: "lastName" },
        { text: this.$t('Common.personnelNumber'), value: "pnr" },
        { text: this.$t('Deputies.deputyType'), value: "deputyType" }
      ]
    }
  },
  methods: {
    open() {
      return this.$refs.deputyDialog.open();
    }
  },
}
</script>